<script src="frontend/node_modules/file-saver/dist/FileSaver.min.js"></script>

<div *ngIf="tieneTopeTasaInteres" class="cucarda">
    <img src="../assets/cucarda.svg" alt="Linea con Tope de Tasa" width="600" height="162">
</div>
<div *ngIf="mostrarMonto" @fade style="text-align: center;">
    <h1 class="big-title red">¿Qué monto necesitás?</h1>
    <p class="big-subtitle red">
        El máximo <span *ngIf="!pymeNueva">para {{ categoriaOriginal.nombre }}</span> es:
        <span class="alerta-top-strong"
              (click)="updateMontoToTotal(montoMax)">
            {{ montoMax | currency : '$' : 'symbol' : '1.0-0' }}
        </span>
    </p>

    <div [ngStyle]="{ visibility: (pymeNueva || ocultarMensajeSuperarMontoMaximo) ? 'hidden' : 'visible' }">
        <p class="dark-gray bold"
           style="font-size:14px; line-height: 1.5; margin-right: 10%; margin-left: 10%; margin-bottom: 220px;">
            Podés superarlo sin problemas<br>sólo cambiarán las condiciones financieras :)</p>
    </div>

    <div class="range-wrap" style="margin: auto;width: 90%;">
        <input
            (change)="updateMonto()"
            [(ngModel)]="total"
            class="range"
            [max]="montoMaxConfiguracion"
            min="0"
            step="10000"
            type="range"
            value="montoMed"
        >
        <output class="bubble-container">$</output>

    </div>

    <div style="margin-top: 50px;">

        <div class="container monto">
            <div class="label red">Crédito</div>

            <div class="big gray">
                <input style="text-align: center;" (keyup)="updateMonto(tooltipAlertaAlto);" [(ngModel)]="total"
                       class="totalInput" [max]="montoMaxConfiguracion"
                       currencyMask [options]="{ thousands: '.', decimal: ',', precision:0 }">
                <mat-icon class="edit-icon">edit</mat-icon>
            </div>
            <div class="col-12" [hidden]="total<=montoMaxConfiguracion">
                <div>
                    <div ngbPopover="El monto ingresado es demasiado alto."
                         #tooltipAlertaAlto='ngbPopover'
                         popoverClass="popOverCustomClass" [placement]="'bottom'">
                    </div>
                </div>
            </div>
        </div>

        <div class="vertical-line"></div>

        <div class="container tasa">
            <div *ngIf="tasaNominal > topeTasaInteres && tieneTopeTasaInteres" class="tasa-tope">{{ topeTasaInteres }}
                %
            </div>
            <div [ngClass]="{'big-title red': true, 'tachado': tasaNominal > topeTasaInteres && tieneTopeTasaInteres }">
                {{ tasaNominal | number:'1.2-2' }}%
            </div>

            <div class="label red">
                Tasa de interés
                <div *ngIf="tieneTopeTasaInteres" class="bold">
                    CON TOPE<sup>*</sup>
                </div>
            </div>
        </div>


        <div style="margin-top: 50px;">
            <h1 class="big-title red">Elegí cómo querés devolverlo:</h1>
        </div>

        <div *ngIf="mostrarSelects" class="demo-grid-ruler mdl-grid">

            <div class="mdl-cell mdl-cell--4-col">

                <div style="display: flex; justify-content: center">
                    <span style="padding-top: 10px;">
                        <h3>Periodicidad de Cuotas</h3>
                    </span>
                    <span>
                    </span>
                </div>
                <mat-form-field appearance="fill">
                    <mat-label><p>Elegí</p></mat-label>
                    <select [(ngModel)]="periodicidadSelected" (change)="setPeriodicidad(periodicidadSelected)"
                            matNativeControl required>
                        <option value=""></option>
                        <option *ngFor="let periodicidad of categoriaCalculadaDetalleLinea.periodicidades"
                                [ngValue]="periodicidad">
                            {{ periodicidad.nombre }}
                        </option>
                    </select>
                </mat-form-field>
            </div>
            <div class="mdl-cell mdl-cell--4-col">
                <div style="display: flex; justify-content: center">
                    <span style="padding-top: 10px;padding-left: 40px;">
                        <h3>Plazo de Gracia</h3>
                    </span>
                    <span>
                        <button mat-icon-button
                                ngbPopover="Las opciones que se muestran son acordes a la periodicidad que elegiste."
                                popoverClass="{{isMobile?'popOverCustomClassMobile':'popOverCustomClass'}}"
                                [placement]="'top'">
                            <mat-icon>error</mat-icon>
                        </button>
                    </span>
                </div>

                <mat-form-field appearance="fill" *ngIf="mostrarGracia">
                    <mat-label><p>Elegí</p></mat-label>
                    <select [(ngModel)]="gracia" (change)="setGracia(gracia)" matNativeControl required>
                        <option value=""></option>
                        <option *ngFor="let item of selectGracia" [value]="item">{{
                                item + ((item == 0 || item > 1) ? ' meses':' mes')
                            }}
                        </option>
                    </select>
                </mat-form-field>
            </div>
            <div class="mdl-cell mdl-cell--4-col">

                <div style="display: flex; justify-content: center">
                    <span style="padding-top: 10px;padding-left: 40px;">
                        <h3>Plazo de Devolución</h3>
                    </span>
                    <span>
                        <button mat-icon-button
                                ngbPopover="Las opciones que se muestran son acordes a la periodicidad que elegiste."
                                popoverClass="{{isMobile?'popOverCustomClassMobile':'popOverCustomClass'}}"
                                [placement]="'top'">
                            <mat-icon>error</mat-icon>
                        </button>
                    </span>
                </div>
                <mat-form-field appearance="fill" *ngIf="mostrarCuotas">
                    <mat-label><p>Elegí</p></mat-label>
                    <select [(ngModel)]="cuotas" (change)="setCuotas(cuotas)" matNativeControl required>
                        <option value=""></option>
                        <option *ngFor="let item of selectCuotas" [value]="item">{{
                                item + ((item == 0 || item > 1) ? ' meses':' mes')
                            }}
                        </option>
                    </select>
                </mat-form-field>
            </div>

        </div>
    </div>
</div>
<div style="text-align: center;" *ngIf="!mostrarTabla">
    <div class="">
        <button class="boton-gris-ftyc" mat-raised-button (click)="checkPymeNueva(false, stepper)">Volver</button>
        <button mat-raised-button (click)="calcular()"
                *ngIf="mostrarMonto && cuotas && gracia && periodicidadSelected?.id && total>0 && total<=montoMaxConfiguracion"
                class="boton-rojo-ftyc">Simular
        </button>
    </div>
</div>
<div *ngIf="mostrarTabla" @fade style="text-align: center;">
    <div class="row justify-content-center text-center">

        <div style="margin-top: 50px; margin-bottom: 50px;">
            <h1 class="big-title red">¡Preparate para Crecer!</h1>
            <p class="big-subtitle red">
                Éste es el detalle de tu crédito
            </p>
        </div>


        <!-- <div class="col-12">
             <div class="row justify-content-center text-left">

                     <div class="row justify-content-around text-left">

                         <div class="col-12">
                             <span style="font-size: 15px;"><b>Monto del Crédito: </b>
                                 {{total | currency : '$' : 'symbol' : '1.0-0' }}
                             </span>
                         </div>

                         <div class="col-12">
                             <span style="font-size: 15px;"><b>Tasa de interés: </b>
                                 {{ tieneTopeTasaInteres ? topeTasaInteres : tasaNominal | number : '1.2-2'}}%
                             </span>
                         </div>

                         <div class="col-12">
                             <span style="font-size: 15px;"><b>Línea </b>
                                 {{categoriaCalculadaDetalleLinea?.linea?.nombre}}:
                                 {{destinoSeleccionado.nombre}}
                             </span>
                         </div>

                         <div class="col-12">
                             <span style="font-size: 15px;"><b>Periodicidad:
                                 </b>{{periodicidadSelected?.nombre}}
                             </span>
                         </div>

                         <div class="col-12">
                             <span style="font-size: 15px;"><b>Plazo de Gracia: </b>
                                 {{cantidadeMesesGraciaFinal}} {{cantidadeMesesGraciaFinal>1? ' meses': ' mes' }}
                             </span>
                         </div>
                         <div class="col-12">
                             <span style="font-size: 15px;"><b>Plazo de Devolución: </b>
                                 {{cantidadCuotasFinal}}{{cantidadCuotasFinal>1? ' meses': ' mes' }}
                             </span>
                         </div>

                     </div>

             </div>
         </div>
         -->


        <div class="col-12">
            <div class="row justify-content-center text-left">
                <div class="row justify-content-around text-left" style="margin-bottom: 30px; width: 100%">
                    <div class="col-12" style="padding: 0">
                        <app-mensaje-importante></app-mensaje-importante>
                    </div>
                </div>
                <div class="bg-darkgray row justify-content-around text-left" style="margin-bottom: 30px;">

                    <div class="col-12">
                            <span style="font-size: 25px; color: white;">Categoría simulada:
                                <b>{{ this.categoriaCalculadaDetalleLinea.categoriaEmpresa.nombre }}</b>
                            </span>
                    </div>

                    <div class="col-12">
                            <span style="font-size: 25px; color: white;">Crédito para:
                                <b>{{ this.destinoSeleccionado.nombre }}</b>
                            </span>
                    </div>

                    <div class="col-12">
                            <span style="font-size: 18px; color: white;">Línea:
                                <b>{{ this.detalleLinea.linea.nombre }}</b>
                            </span>
                    </div>

                </div>
                <div class="bg-red row justify-content-around text-left" style="margin-bottom: 30px;">

                    <div class="col-12">
                            <span style="font-size: 25px; color: white;">Monto del Crédito:
                                <b>{{ total | currency : '$' : 'symbol' : '1.0-0' }}</b>
                            </span>
                    </div>

                    <div class="col-12">
                        <span style="font-size: 25px; color: white;">Tasa de interés: </span>

                        <span style="font-size: 25px; color: white;" [ngClass]="{ 'tachado': tieneTopeTasaInteres }">
                              {{ tieneTopeTasaInteres ? (tasaNominal | number : '1.2-2') + '%' : (tasaNominal | number : '1.2-2') + '%' }}
                            </span>

                        <ng-container *ngIf="tieneTopeTasaInteres">
                              <span style="font-size: 25px; color: white;">
                                <b> CON TOPE*: {{ topeTasaInteres | number : '1.2-2' }}%</b>
                              </span>
                        </ng-container>
                    </div>


                    <div class="col-12">
                            <span style="font-size: 18px; color: white;">Máximo a financiar:
                                <b>
                                    {{ this.categoriaCalculadaDetalleLinea.porcentajeInversion }}% del total del proyecto{{ sinIva ? ' sin iva' : '' }}
                                    .
                                </b>
                            </span>
                    </div>

                </div>
                <div class="bg-gray row justify-content-around text-left" style="margin-bottom: 30px;">

                    <div class="col-12">
                            <span style="font-size: 20px; color: gray;">Plazo de Devolución:
                                <b>{{ cantidadCuotasFinal }}{{ cantidadCuotasFinal > 1 ? ' meses' : ' mes' }}</b>
                            </span>
                    </div>

                    <div class="col-12">
                            <span style="font-size: 20px; color: gray;">Plazo de Gracia:
                                <b>{{ cantidadeMesesGraciaFinal }} {{ cantidadeMesesGraciaFinal > 1 ? ' meses' : ' mes' }}</b>
                            </span>
                    </div>

                    <div class="col-12">
                            <span style="font-size: 20px; color: gray;">Periodicidad:
                                <b>{{ periodicidadSelected?.nombre }}</b>
                            </span>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <div class="row justify-content-center text-center">
        <div class="col-12">
            <br>
        </div>
    </div>
    <div class="row justify-content-center text-center">
        <div class="col-12">
            <div class="row justify-content-center text-center align-items-center">
                <div class="col-lg-12 col-sm-12" style="margin-bottom: 50px">
                    <div class="col-12">
                        <div style="text-align: center; overflow-x: auto; max-height: 70vh" class="mat-elevation-z8">
                            <table [dataSource]="dataSource" class="mat-elevation-z8 table-striped" mat-table option>
                                <ng-container matColumnDef="nro">
                                    <th *matHeaderCellDef mat-header-cell class="tableHeaderColumns"
                                        [ngClass]="isMobile? 'fontTableMobile':''">{{ isMobile ? 'Vto.' : 'Vencimiento' }}
                                    </th>
                                    <td *matCellDef="let element" mat-cell [ngClass]="isMobile? 'fontTableMobile':''">
                                        {{ element.nro == 0 ? '' : element.nro }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="periodo">
                                    <th *matHeaderCellDef mat-header-cell class="tableHeaderColumns"
                                        [ngClass]="isMobile? 'fontTableMobile':''">Plazos
                                    </th>
                                    <td *matCellDef="let element" mat-cell [ngClass]="isMobile? 'fontTableMobile':''">
                                        {{ element.periodo }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="saldo">
                                    <th *matHeaderCellDef mat-header-cell class="tableHeaderColumns"
                                        [ngClass]="isMobile? 'fontTableMobile':''">Saldo
                                    </th>
                                    <td *matCellDef="let element" mat-cell [ngClass]="isMobile? 'fontTableMobile':''">
                                        {{ element.saldo | currency:'$': 'symbol' :'1.0-0' }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="capital">
                                    <th *matHeaderCellDef mat-header-cell class="tableHeaderColumns"
                                        [ngClass]="isMobile? 'fontTableMobile':''">Capital
                                    </th>
                                    <td *matCellDef="let element" mat-cell [ngClass]="isMobile? 'fontTableMobile':''">
                                        {{ element.capital | currency:'$': 'symbol' :'1.0-0' }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="interes">
                                    <th *matHeaderCellDef mat-header-cell class="tableHeaderColumns"
                                        [ngClass]="isMobile? 'fontTableMobile':''">Intereses
                                    </th>
                                    <td *matCellDef="let element" mat-cell [ngClass]="isMobile? 'fontTableMobile':''">
                                        {{ element.interes | currency:'$': 'symbol' :'1.0-0' }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="cuota">
                                    <th *matHeaderCellDef mat-header-cell class="tableHeaderColumns"
                                        [ngClass]="isMobile? 'fontTableMobile':''"> Cuota
                                    </th>
                                    <td *matCellDef="let element" mat-cell [ngClass]="isMobile? 'fontTableMobile':''">
                                        {{ element.cuota | currency:'$': 'symbol' :'1.0-0' }}
                                    </td>
                                </ng-container>
                                <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
                                <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
                            </table>
                        </div>
                        <mat-toolbar class="mat-elevation-z8">
                            <mat-toolbar-row *ngIf="!modoConsulta">
                                <div class="col-lg-12 col-sm-12">
                                    <div class="row justify-content-center text-center align-items-center">
                                        <div class="col-lg-2 col-sm-6"
                                             [style]="isMobile? 'width:50%; text-align: left;':''">
                                            <button mat-icon-button (click)="imprimirSimulacion()"
                                                    [style]="isMobile? 'width:100%;':''">
                                                <mat-icon title="Descargar PDF">save_alt</mat-icon>
                                                PDF
                                            </button>
                                        </div>
                                        <div class="col-lg-2 col-sm-6"
                                             [style]="isMobile? 'width:50%; text-align: left;':''">
                                            <button mat-icon-button (click)="sendEmail()"
                                                    [style]="isMobile? 'width:100%;':''">
                                                <mat-icon title="Enviar a Email">email</mat-icon>
                                                Email
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </mat-toolbar-row>
                        </mat-toolbar>
                    </div>
                </div>
                <div class="col-lg-12 col-sm-12">
                    <div class="row justify-content-center text-center align-items-center">
                        <div class="col-lg-2 col-sm-12">
                            <button style="width: 100%" class="boton-gris-ftyc boton-wrap-text" mat-raised-button
                                    (click)="volverPrimerPaso()">Modificá el Monto
                            </button>
                        </div>

                        <div class="col-lg-3 col-sm-12">
                            <button style="width: 100%" class="boton-gris-ftyc boton-wrap-text" mat-raised-button
                                    (click)="simularOtroCredito(stepper)">Simulá otro Crédito
                            </button>
                        </div>

                        <div class="col-lg-4 col-sm-12">
                            <button style="width: 100%" class="boton-rojo-ftyc boton-wrap-text" mat-raised-button
                                    (click)="gotoftyc._elementRef.nativeElement.click();">Conocé las Condiciones
                                Financieras
                            </button>
                            <a [hidden]="true" #gotoftyc target="_blank" style="width: 100%" class="boton-gris-ftyc"
                               mat-raised-button [href]="categoriaCalculadaDetalleLinea?.linea?.enlaceExterno">
                                Conocé las Condiciones Financieras
                            </a>
                        </div>
                        <div class="col-lg-3 col-sm-12">
                            <button style="width: 100%" class="boton-verde-ftyc boton-wrap-text" mat-raised-button
                                    (click)="gotofwhatsapp._elementRef.nativeElement.click();">Contactá a un asesor
                            </button>
                            <a [hidden]="true" #gotofwhatsapp target="_blank" style="width: 100%"
                               class="boton-gris-ftyc" mat-raised-button
                               href="https://api.whatsapp.com/send/?phone=5492612050154&text=Hola+FTyC%2C+necesito+hacer+una+consulta%21&app_absent=0">
                                Contactá a un asesor
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="row justify-content-center text-center" style="margin-top: 50px;">
        <div class="col-12">
            <div class="row justify-content-center text-left">
                <div class="col-lg-8 col-sm-11" *ngIf="pymeNueva">
                    <p style="line-height: 15px;">
                        <small>
                            El presente desarrollo no constituye oferta del FTyC (Administradora Provincial del Fondo),
                            sólo tiene carácter informativo y orientativo para el interesado.
                            El resultado que surja del simulador es meramente referencial y establecido a partir de los
                            datos ingresados por cuenta propia del interesado. Los préstamos quedan sujetos a las
                            condiciones de aprobación establecidas por el FTyC. Los gastos de otorgamiento no están
                            contemplados en la simulación.
                        </small>
                    </p>
                    <p style="line-height: 15px;">
                        <small>
                            Los intereses son estimados y se calculan según la Tasa Nominal Anual activa de cartera
                            general del Banco de la Nación Argentina con fecha: {{ fechaTasa | date: 'dd/MM/yyyy' }}.
                            El Plazo de Gracia es el período durante el cual no se pagan cuotas de capital y únicamente
                            se pagan los intereses del préstamo.
                        </small>
                    </p>
                    <p style="line-height: 15px;">
                        <small>
                            Por ser una empresa nueva (start up) el monto final del financiamiento y la tasa de interés
                            serán los que resulten del análisis del proyecto y de la valoración de la garantía que
                            presentes.
                        </small>
                    </p>
                </div>
                <div class="col-lg-8 col-sm-11" *ngIf="!pymeNueva">
                    <p style="line-height: 15px;">
                        <small>
                            El presente desarrollo no constituye oferta del FTyC (Administradora Provincial del Fondo),
                            sólo tiene carácter informativo y orientativo para el interesado. El resultado que surja del
                            simulador es meramente referencial y establecido a partir de los datos ingresados por cuenta
                            propia del interesado.
                            Los préstamos quedan sujetos a las condiciones de aprobación establecidas por el FTyC. Los
                            gastos de otorgamiento no están contemplados en la simulación.
                        </small>
                    </p>
                    <p style="line-height: 15px;">
                        <small>
                            Los intereses son estimados y se calculan según la Tasa Nominal Anual activa de cartera
                            general del Banco de la Nación Argentina con fecha: {{ fechaTasa | date: 'dd/MM/yyyy' }}.
                            El Plazo de Gracia es el período durante el cual no se pagan cuotas de capital y únicamente
                            se pagan los intereses del préstamo.
                        </small>
                    </p>
                </div>
                <div class="col-lg-8 col-sm-11" *ngIf="tieneTopeTasaInteres">
                    <p style="line-height: 15px;">
                        <small>
                            *TOPE DE TASA<Br>
                            Si bien la tasa de interés es variable y se calcula como una proporción de la Tasa Nominal
                            Anual activa de cartera general del Banco de la Nación Argentina, en las solicitudes que
                            ingresen hasta el 31/12/23, la tasa de interés aplicable no podrá superar el 30% para
                            Microagro,
                            45% para Micro, 55% para Pequeñas y el 65% para Medianas empresas.
                        </small>
                    </p>
                </div>
            </div>
        </div>
    </div>

</div>
